import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import { RUN_STATUS, RUN_STATUS_META } from "@/profitability/constants";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";

export const RunStatus = ({ run }: { run: EnrichedProfitabilityPeriod }) => {
  const meta = RUN_STATUS_META[run.status];
  return (
    <Stack gap={1} align="start">
      <Badge variant="secondary" color={meta.color} size="sm">
        {meta.label}
      </Badge>
      {run.display.latestAttemptMessage && (
        <span className="text-xs text-subtle">
          {run.display.latestAttemptMessage}
        </span>
      )}
      {run.status === RUN_STATUS.failed && run.error?.message && (
        <span
          className="line-clamp-2 text-xs text-subtle"
          title={run.error.message}
        >
          {run.error.message}
        </span>
      )}
    </Stack>
  );
};
